module.exports = __webpack_public_path__ + "img/1_custum-car-sp.2477a0dc.gif";